import React from 'react';
import { Box, IconButton } from '@mui/material';
import { ViewModule, ViewList, ViewAgenda, Apps, FolderOpen } from '@mui/icons-material';
import { PrimaryButton } from '../../components/ui/button';
import PropTypes from 'prop-types';
import fileIcon from '../assets/images/fileicon.png';

const WorkspaceHeaderActions = ({ viewMode, setViewMode }) => {
  return (
    <>
      <Box
        data-tour="workspace-views"
        sx={{
          display: 'flex',
          gap: { xs: 0.25, sm: 0.5 },
          bgcolor: 'white',
          border: '1px solid #e6e6e6',
          borderRadius: '4px',
          p: { xs: 0.25, sm: 0.5 },
          boxShadow: '0px 0px 4px 0px rgba(0,0,0,0.05)',
        }}
      >
        <IconButton
          size="small"
          onClick={() => setViewMode('cards')}
          sx={{
            bgcolor: viewMode === 'cards' ? '#ecfdf5' : 'transparent',
            '&:hover': { bgcolor: viewMode === 'cards' ? '#ecfdf5' : '#f5f5f5' },
            p: { xs: 0.75, sm: 1 },
          }}
          title="Cards View"
        >
          <ViewModule sx={{ fontSize: { xs: '1rem', sm: '1.125rem' }, color: viewMode === 'cards' ? '#3b9562' : '#525252' }} />
        </IconButton>
        <IconButton
          size="small"
          onClick={() => setViewMode('tiles')}
          sx={{
            bgcolor: viewMode === 'tiles' ? '#ecfdf5' : 'transparent',
            '&:hover': { bgcolor: viewMode === 'tiles' ? '#ecfdf5' : '#f5f5f5' },
            p: { xs: 0.75, sm: 1 },
          }}
          title="Tiles View"
        >
          <Apps sx={{ fontSize: { xs: '1rem', sm: '1.125rem' }, color: viewMode === 'tiles' ? '#3b9562' : '#525252' }} />
        </IconButton>
        <IconButton
          size="small"
          onClick={() => setViewMode('list')}
          sx={{
            bgcolor: viewMode === 'list' ? '#ecfdf5' : 'transparent',
            '&:hover': { bgcolor: viewMode === 'list' ? '#ecfdf5' : '#f5f5f5' },
            p: { xs: 0.75, sm: 1 },
          }}
          title="List View"
        >
          <ViewList sx={{ fontSize: { xs: '1rem', sm: '1.125rem' }, color: viewMode === 'list' ? '#3b9562' : '#525252' }} />
        </IconButton>
        <IconButton
          size="small"
          onClick={() => setViewMode('details')}
          sx={{
            bgcolor: viewMode === 'details' ? '#ecfdf5' : 'transparent',
            '&:hover': { bgcolor: viewMode === 'details' ? '#ecfdf5' : '#f5f5f5' },
            p: { xs: 0.75, sm: 1 },
          }}
          title="Details View"
        >
          <ViewAgenda sx={{ fontSize: { xs: '1rem', sm: '1.125rem' }, color: viewMode === 'details' ? '#3b9562' : '#525252' }} />
        </IconButton>
      </Box>
      <IconButton
        sx={{
          bgcolor: 'white',
          border: '1px solid #e6e6e6',
          boxShadow: '0px 0px 4px 0px rgba(0,0,0,0.05)',
          '&:hover': { bgcolor: '#f9f9f9' },
          p: { xs: 1, sm: 1.5 },
        }}
      >
        <Box
          component="img"
          src={fileIcon}
          alt="File"
          sx={{ width: { xs: 16, sm: 19.5 }, height: { xs: 16, sm: 19.5 } }}
        />
      </IconButton>
      <PrimaryButton
        variant="contained"
        startIcon={<FolderOpen sx={{ fontSize: { xs: '1rem', sm: '1.25rem' } }} />}
        sx={{
          height: { xs: 32, sm: 36 },
          px: { xs: 1.25, sm: 1.75 },
          fontSize: { xs: '0.75rem', sm: '0.875rem' },
        }}
        data-tour="create-project"
      >
        Project
      </PrimaryButton>
    </>
  );
};

WorkspaceHeaderActions.propTypes = {
  viewMode: PropTypes.string.isRequired,
  setViewMode: PropTypes.func.isRequired,
};

export default WorkspaceHeaderActions;
